import type { IconSvgObject } from './types';

const PackageMovingIcon: IconSvgObject = [
  ["path", { d: "M12.5 10L21.5 6L12.5 2L3.5 6L12.5 10Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 4L8 8", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3.5 6V10M2.5 19.3339H6.5L12.4961 22M12.4961 22L21.5 18V6.01357M12.4961 22V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2.5 13H5.5M2.5 16H5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default PackageMovingIcon;
